import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteModule } from '@autocomplete';
import { MaterialModule } from '@material';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule } from 'ngx-mask';
import { CoreModule } from '../../../core/core.module';
import { PipeModule } from '../../../pipes/pipes.module';
import { InvoiceDirectivesModule } from '../../directives/invoice-directives/invoice-directives.module';
import { CopyClipboardModule } from '../../modules/copy-clipboard/copy-clipboard.module';
import { NgStfAccordeonModule } from '../../modules/ng-stf-accordeon/ng-stf-accordeon.module';
import { PhoneInputModule } from '../../modules/phone-input/phone-input.module';
import { CheckboxFilterComponent } from './components/checkbox-filter/checkbox-filter.component';
import { FilterChipListComponent } from './components/filter-chip-list/filter-chip-list.component';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { DoubleDateFilterComponent } from './components/double-date-filter/double-date-filter.component';
import { DoubleNumberInputFilterComponent } from './components/double-number-input-filter/double-number-input-filter.component';
import { InputFilterComponent } from './components/input-filter/input-filter.component';
import { NumberInputFilterComponent } from './components/number-input-filter/number-input-filter.component';
import { AutocompleteFilterComponent } from './components/autocomlete-filter/autocomplete-filter.component';
import { PhoneNumberFilterComponent } from './components/phone-number-filter/phone-number-filter.component';
import { RadioFilterComponent } from './components/radio-filter/radio-filter.component';
import { TableFilterMenuFooterComponent } from './components/table-filter-menu-footer/table-filter-menu-footer.component';
import {
  TableFilterMenuHeaderComponent
} from './components/table-filter-menu-header/table-filter-menu-header.component';
import {
  HotDoubleDateFilterComponent
} from './components/table-hot-filters/components/hot-double-date-filter/hot-double-date-filter.component';
import { HotInputFilterComponent } from './components/table-hot-filters/components/hot-input-filter/hot-input-filter.component';
import { HotRadioFilterComponent } from './components/table-hot-filters/components/hot-radio-filter/hot-radio-filter.component';
import { HotSearchInputFilterComponent } from './components/table-hot-filters/components/hot-search-input-filter/hot-search-input-filter.component';
import { TableHotFiltersComponent } from './components/table-hot-filters/table-hot-filters.component';
import { TableFilterMenuComponent } from './table-filter-menu.component';

const COMPONENTS = [
  TableFilterMenuComponent,
  RadioFilterComponent,
  CheckboxFilterComponent,
  AutocompleteFilterComponent,
  InputFilterComponent,
  PhoneNumberFilterComponent,
  DateFilterComponent,
  NumberInputFilterComponent,
  DoubleDateFilterComponent,
  DoubleNumberInputFilterComponent,
  TableFilterMenuHeaderComponent,
  TableFilterMenuFooterComponent,
  TableHotFiltersComponent,
  HotInputFilterComponent,
  HotRadioFilterComponent,
  HotDoubleDateFilterComponent,
  HotSearchInputFilterComponent,
  FilterChipListComponent
];

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PhoneInputModule,
    PipeModule,
    CopyClipboardModule,
    NgStfAccordeonModule,
    CoreModule,
    InvoiceDirectivesModule,
    TextMaskModule,
    NgxMaskModule.forRoot()
  ],
  declarations: COMPONENTS,
  exports: [...COMPONENTS, NgxMaskModule, AutocompleteModule],
})
export class TableFilterMenuModule {}
